<template>
  <div class="sign">

    <div class="left">
      <img class="logo" src="../../assets/img/logo-new.png" alt />
    </div>
    <div class="right">

      <div class="btn-return" @click="$router.push({ name: 'signIn' })"> <i class="el-icon-arrow-left"></i> <I18Lang id="user105" defaultText="重置密码" />
      </div>

      <div class="sign-form">

        <el-form :model="formData" :rules="rules" ref="formData" class="reset-from">
          <el-form-item prop="username">
            <el-input v-model="formData.username" :placeholder="$t('user24')"></el-input>
          </el-form-item>

          <el-form-item prop="password">
            <el-input type="password" v-model="formData.password" :placeholder="$t('user6')" show-password></el-input>
          </el-form-item>

          <el-form-item prop="code">
            <el-input class="get-code" v-model="formData.code" placeholder="请输入助记词">
              <!-- <template slot="append">
                <SendCode class="btn-send-code" v-model="isSendCode" @click.native="sendEmailCode"
                  storage-key="regPhoneCode" :initStr="$t('user94')" :class="{ 'btn-loading': sendLoading }" />
              </template> -->
            </el-input>
            <div v-if="viewEmail&&viewEmail.email" class="desc">
              <I18Lang id="public40" defaultText="验证码发送" />{{ viewEmail.email }}
            </div>
          </el-form-item>

          <el-form-item>
            <el-button :loading="isSubmitLoading" type="primary" class="btn-view btn-red"
              @click="submitForm('formData')">
              <I18Lang id="user71" defaultText="确定" />
            </el-button>
          </el-form-item>

        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import SendCode from '@/components/SendCode/SendCode.vue'
import i18n from '@utils/i18n'
import http from '@utils/http'
export default {
  data () {
    const validateName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(i18n.t('public8'))) // 请输入姓名
      } else {
        http
          .post('/api/user/checkIsExist', { username: value })
          .then((result) => {
            if (result.is_exist) {
              callback()
            } else {
              callback(new Error(i18n.t('public78'))) // 用户名已经存在，请填写其他用户名
              return false
            }
          })
      }
    }

    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(i18n.t('user25'))) // 请输入密码
      } else if (value.length < 8) {
        callback(new Error(i18n.t('public12'))) // 密码长度不能小于8位
      } else if (value.length > 16) {
        callback(new Error(i18n.t('public13'))) // 密码长度不能大于16位
      } else if (!/^(?![^a-zA-Z]+$)(?!\D+$)/.test(value)) {
        callback(new Error(i18n.t('public14'))) // 必须同时包含数字和字母
      } else {
        if (this.formData.rePassword !== '') {
          this.$refs.formData.validateField('rePassword')
        }
        callback()
      }
    }

    return {
      sendLoading: false,
      isSendCode: false,
      isSubmitLoading: false,
      viewEmail: '',
      formData: {
        username: '',
        code: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, validator: validateName, trigger: 'blur' }
        ],
        code: [
          { required: true, message: i18n.t('text64'), trigger: 'blur' }
        ],
        password: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    usernameBlur () {
      this.$refs.formData.validateField(['username'], result => {
        if (!result) {
          this.$http.post('/api/user/viewEmail', { username: this.formData.username }).then((result) => {
            this.viewEmail = result
          })
        }
      })
    },
    setEmailInput (mail) {
      this.formData.email = mail
    },
    sendEmailCode () {
      if (!this.viewEmail.email) {
        return
      }
      const params = {
        email: this.viewEmail.email,
        event: 'forget_find_password'
      }
      this.sendLoading = true
      this.$http.post(this.viewEmail.verify_email ? '/api/email/send' : '/api/sms/send', params).then((result) => {
        this.isSendCode = true
        this.sendLoading = false
      }).catch(() => {
        this.sendLoading = false
      })
    },
    submitForm (formName) {
      this.isSubmitLoading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submit()
        } else {
          this.isSubmitLoading = false
          console.log('error submit!!')
          return false
        }
      })
    },
    submit () {
      this.$http.post('/api/user/forgetPassword', this.formData).then(result => {
        this.isSubmitLoading = false
        this.$alert('Your password has been reset successfully. Please log in again', {
          confirmButtonText: this.$t('my25'),
          center: true,
          customClass: 'success-alert',
          callback: action => {
            this.$router.push({ name: 'signIn' })
          }
        })
      }).catch(() => {
        this.isSubmitLoading = false
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  },
  components: {
    SendCode
  }
}
</script>

<style scoped lang="scss">
.sign {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  .left {
    flex: 0 0 50%;
    height: 100%;
    background: url('../../assets/img/sign/bg-wjmm.png') no-repeat center / auto 100%;

    .logo {
      width: 200px;
      position: absolute;
      top: 67px;
      left: 78px;
    }
  }

  .right {
    flex: 0 0 50%;
    height: 100%;
    overflow-y: auto;
    padding-top: 48px;
    padding-bottom: 57px;

    .btn-return {
      font-size: 20px;
      font-family: Arial;
      font-weight: bold;
      color: #00CCFF;
      line-height: 37px;
      margin-left: 48px;
      display: inline-flex;
      align-items: center;
      margin-bottom: 32px;
      cursor: pointer;

      i {
        width: 56px;
        height: 56px;
        border: 1px solid #143c4c;
        border-radius: 50%;
        color: #00CCFF;
        text-align: center;
        line-height: 56px;
        margin-right: 20px;
        font-weight: bold;
      }
    }
  }

  .sign-form {
    width: 440px;
    margin: 0 auto;

    .reset-from {

      .form-item {
        margin-bottom: 35px;

        .form-item-label {
          font-size: 16px;
          font-weight: 400;
          color: #01B2F5;
        }

        .form-item-value {
          font-size: 18px;
          font-weight: bold;
          color: #FFFFFF;
        }
      }

      ::v-deep .el-form-item {
        .el-form-item__label {
          font-size: 16px;
          font-family: Arial;
          font-weight: 400;
          color: #01B2F5;
        }

        input:-webkit-autofill {
          transition: background-color 5000s ease-out 0.5s;
          -webkit-text-fill-color: #fff;
        }

        .el-input__inner {
          width: 440px;
          height: 40px;
          border: 1px solid rgba(1, 178, 245, 0.5);
          line-height: 40px;
          background: transparent;
          color: #fff;
          border-radius: 0;
        }
      }

      .reset-input-code {
        ::v-deep {
          .el-input__inner {
            width: 100%;
            border-right: none;
          }

          .el-input-group__append {
            background: transparent;
            border: 1px solid rgba(1, 178, 245, 0.5);
            border-left: none;
            border-radius: 0;

            .btn {
              color: #01B2F5;
            }
          }
        }
      }

      .btn-submit {
        width: 110px;
        height: 55px;
        line-height: 55px;
        margin-left: -10px;
      }
    }

    .desc {
      font-size: 16px;
      color: #00CCFF;
    }

    .btn-view {
      width: 100%;
      height: 48px;
      font-size: 16px;

      &.btn-red {
        background: #01B2F5;
        border-color: #01B2F5;
        border-radius: 0;
      }
    }
  }
}
</style>
